@import '../../sass/base/helpers';

som-pagination {
  .pagination-container {
    display: flex;

    &__grid {
      justify-content: space-between;
      align-items: center;
      border-bottom-left-radius: 2px;
      border-bottom-right-radius: 2px;
      border: 1px solid $border-color;
      border-top: none;
      padding: .5rem 1.5rem .5rem .5rem;

      &.no-border {
        border: none;
        padding: .5rem 0;
      }
    }

    &__page {
      flex-direction: column-reverse;
      justify-content: center;
      align-items:center;

      .pagination-items {
        margin-bottom: 1rem;
      }
    }

    .pagination {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
  
      som-button {
        .btn-white {
          background-color: transparent;
  
          &:hover {
            background-color: $smoke;
            background-blend-mode: multiply;
          }
        }
      }
  
      &__previous {
        //margin-right: 1rem;
        min-width:2rem;  // This is used to minimize the redraw when page changes
      }
  
      &__next {
        //margin-left: 1rem;
        min-width:2rem;  // This is used to minimize the redraw when page changes
      }
  
      &__mobile {
        display: block !important;
      }
  
      &__desktop {
        display: none !important;
      }
  
      @include media-breakpoint-up("md") { 
        &__mobile {
          display: none !important;
        }
  
        &__desktop {
          display: flex !important;
        }
      }
  
    }
  
  
    ul {
      list-style: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-direction: row;
  
      li {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 2px; // allows focus ring to not get cutoff
        min-width:2rem; // This is used to minimize the redraw when page changes
  
        .three-dots {
          width: 1rem;
          text-align: center;
  
          &::after {
            content: " \B7 \B7 \B7 ";
          }
        }
      }
    }

    .pagination-items {
      @include text-type(6, 500);
    }
  }
}
